<audio #soundBeep>
  <source src="./assets/beep.mp3" type="audio/mpeg">
</audio>

<h4 class="pt-0 pl-4">Выдача посылок</h4>
<div class="p-fluid p-6">
  <h5>Выберите клиента</h5>

  <div class="pb-1">
    <p-autoComplete [(ngModel)]="selectedClient" [suggestions]="filteredClients" (completeMethod)="filterItems($event)"
      (onSelect)="clientSelected()" field="client_code" [minLength]="1" [virtualScroll]="true"
      [virtualScrollItemSize]="34" [style]="{'width':'100%'}" [dropdown]="true" placeholder="Выберите клиента" appendTo="body">
    </p-autoComplete>
  </div>

  @if(selectedClient) {
  <div class="pb-1">
    <input pInputText placeholder="Введите трек-номер" [(ngModel)]="tracknum" (keyup)="onKeyUp($event)" autofocus #tracknumInput class="w-full">
  </div>
  <div class="pb-4">
    <input pInputText placeholder="Комментарий" [(ngModel)]="trackComment" class="w-full">
  </div>
  <div class="flex justify-end flex-wrap">
    <p-button label="Выдать посылку" (click)="deliverPackage()"></p-button>
  </div>

  <div class="w-full pt-8">
    <p-table [value]="clientTracks" [tableStyle]="{ 'min-width': '50rem' }">
      <ng-template #header>
        <tr>
          <th>#</th>
          <th>Трэк-номер</th>
          <th>Название</th>
          <th>Дата</th>
          <th>Статус</th>
        </tr>
      </ng-template>
      <ng-template #body let-track let-rowIndex="rowIndex">
        <tr (click)="pasteTracknum(track.tracknum)">
          <td>{{rowIndex+1}}</td>
          <td>{{track.tracknum}}</td>
          <td>{{track.title}}</td>
          <td>{{track.dt | date: 'dd.MM.yyyy'}}</td>
          <td>
            {{track.status}}
            {{track.store_days && track.store_days > 0 ? " ("+track.store_days+")" : "" }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  }